export default __webpack_public_path__ + "media/images/brands/white-company-75f04d49f9961053dfa0d41b3da27f19.png";